import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseSiteService,
  CmsService,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { CheckoutService } from 'src/app/shared/modules/checkout/checkout.service';
import { RequestSupportComponent } from 'src/app/shared/modules/request-support/request-support.component';
import { AccountOverviewService } from '../../account-overview.service';

@Component({
  selector: 'app-acc-my-account',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './acc-my-account.component.html',
  styleUrls: ['./acc-my-account.component.scss'],
})
export class AccMyAccountComponent implements OnInit, OnDestroy {
  userAccountgetData: any;
  userAccountDataSubscriber: Subscription;
  userProfileAccountDataSubscriber: any;
  userAccData: any;
  accntId: any = '';
  AccountOverviewService: any;
  userAccDetailsData: any;
  baseUrl: string;
  customerRepDetails: any = [];
  baseSub: Subscription;

  constructor(
    private readonly modalService: NgbModal,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly cmsService: CmsService,
    private readonly router: RoutingService,
    private readonly checkoutService: CheckoutService,
    private readonly occService: OccEndpointsService,
    private readonly baseSiteService: BaseSiteService,
    private readonly accOverviewService: AccountOverviewService
  ) {}

  baseSiteId: string;

  getUserAccountData(userId): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.userAccountDataSubscriber = this.pfService._userAccountData.subscribe(
      (userData) => {
        if (userData) {
          this.accntId = userData?.defaultB2BUnit?.uidNonLeadingZero;
          this.accOverviewService
            .getSalesRep(this.baseSiteId, userId, userData?.defaultB2BUnit?.uid)
            .subscribe((resp) => {
              if (resp?.salesRepList) {
                this.customerRepDetails = resp?.salesRepList;
                this.ref.detectChanges();
              }
            });
          this.ref.detectChanges();
        }
        this.userAccountDataSubscriber?.unsubscribe();
      }
    );
  }

  getUserProfileAccData(userId, accId): void {
    this.userProfileAccountDataSubscriber =
      this.pfService.userProfileAccountData.subscribe((userProfileData) => {
        if (userProfileData?.res && userProfileData?.res?.length !== 0) {
          this.userAccData = userProfileData?.res;
          this.userAccDetailsData =
            userProfileData?.res?.sanofiEmployeeDataList;
          this.ref.detectChanges();
        }
        this.userProfileAccountDataSubscriber?.unsubscribe();
      });
  }

  ngOnInit(): void {
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userAccountgetData = res;
        this.ref.detectChanges();
        this.getUserAccountData(this.userAccountgetData.userName);
      }
    });

    this.baseUrl = this.occService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  openModal() {
    this.modalService.open(RequestSupportComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `${this.baseSiteId}`,
    });
  }

  navigateToAccountTab() {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Address(s) of Business Unit(s)');
  }

  getImage(data: any) {
    if (data) {
      return `${this.baseUrl}${data.profilePic}`;
    } else {
      return undefined;
    }
  }

  formatPhoneNumber(phone) {
    var cleaned = ('' + phone).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '1' : '';
      return [intlCode, '(', match[2], ')', '-', match[3], '-', match[4]].join(
        ''
      );
    }
    return null;
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.userAccountDataSubscriber?.unsubscribe();
    this.userProfileAccountDataSubscriber?.unsubscribe();
  }
}
